export { default as DigitalAssetEdit } from './Edit';
export { default as DigitalAssetMain } from './Main';
